import React from 'react';
import { Text, Stack } from '@atlaskit/primitives';

import InlineMessage from '@atlaskit/inline-message';
import Link from '@atlaskit/link';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const COMMUNITY_POST_LINK =
	'https://community.atlassian.com/forums/Jira-articles/Creating-subtasks-within-epics-in-the-work-item-panel/ba-p/2982758';

const InlineHeaderMessageInfoPanel = () => {
	const { formatMessage } = useIntl();

	return (
		<InlineMessage appearance="info">
			<Stack space="space.150">
				<Text as="p">
					<Text as="strong">{formatMessage(messages.title)}</Text>
				</Text>
				<Stack space="space.100">
					<Stack space="space.050">
						<Text as="p">{formatMessage(messages.coreMessage)}</Text>
						<Text as="p">{formatMessage(messages.createActionMessage)}</Text>
					</Stack>
					<Link href={COMMUNITY_POST_LINK}>{formatMessage(messages.communityPostLink)}</Link>
				</Stack>
			</Stack>
		</InlineMessage>
	);
};

export default InlineHeaderMessageInfoPanel;
